// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили для всех React компонентов */

/* Сброс стилей */
* {
  box-sizing: border-box;
  margin: 0;
}

/* Общие переменные */
:root {
  --primary-color: #007bff;
  --text-color: #333;
  --border-color: #e0e0e0;
  --background-light: #f8f8f8;
  --max-width: 1200px;
  --border-radius: 4px;
  --box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* Общие классы */
.container {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 20px;
}

.btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: var(--border-radius);
  transition: all 0.3s ease;
}

.btn:hover {
  background: var(--background-light);
}

.btn-primary {
  background: var(--primary-color);
  color: white;
}

.btn-primary:hover {
  background: #0056b3;
}

/* Утилиты */
.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-center {
  justify-content: center;
}

.text-center {
  text-align: center;
}

.w-100 {
  width: 100%;
}

.h-100 {
  height: 100%;
}

.mb-0 {
  margin-bottom: 0;
}

.mt-0 {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,iBAAiB;AACjB;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Общие стили для всех React компонентов */\n\n/* Сброс стилей */\n* {\n  box-sizing: border-box;\n  margin: 0;\n}\n\n/* Общие переменные */\n:root {\n  --primary-color: #007bff;\n  --text-color: #333;\n  --border-color: #e0e0e0;\n  --background-light: #f8f8f8;\n  --max-width: 1200px;\n  --border-radius: 4px;\n  --box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n/* Общие классы */\n.container {\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: var(--border-radius);\n  transition: all 0.3s ease;\n}\n\n.btn:hover {\n  background: var(--background-light);\n}\n\n.btn-primary {\n  background: var(--primary-color);\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #0056b3;\n}\n\n/* Утилиты */\n.d-flex {\n  display: flex;\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.justify-content-between {\n  justify-content: space-between;\n}\n\n.justify-content-center {\n  justify-content: center;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.h-100 {\n  height: 100%;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.mt-0 {\n  margin-top: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
